<mat-progress-bar class="progress-margin login-container" color="primary" *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div class="card-container">
  <question-component #questionComponent
                      (questionsfinished)="onQuestionsFinished($event)"
                      (questionsredo)="onQuestionsRedo()"
                      [reservation-question]="reservationQuestion"></question-component>
</div>
